<template>
  <div>
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <Form ref="formStep1" :label-width="120" :model="formItem">
      <FormItem label="设备类型：">
        <Select v-model="formItem.meterType">
          <Option value="1">智能管理阀</Option>
          <Option value="0">智能燃气表</Option>
        </Select>
      </FormItem>
      <FormItem label="操作类型：">
        <Select v-model="formItem.operatationType">
          <Option value="1" v-show="formItem.meterType == '0'">查询</Option>
          <Option value="0">下发</Option>
        </Select>
      </FormItem>
      <FormItem label="特征值下发参数：" v-show="formItem.meterType == '0'">
        <Select v-model="formItem.operatation">
          <Option value="1">标定</Option>
          <Option value="0">读取</Option>
        </Select>
      </FormItem>
      <FormItem label="标定类型：" v-show="formItem.meterType == '1'">
        <Select v-model="formItem.operatation">
          <Option value="0">标定：开始</Option>
          <Option value="1">标定：结束</Option>
          <Option value="2">二次修正</Option>
        </Select>
      </FormItem>
      <FormItem label="表底数：" v-show="formItem.meterType == '1'">
        <Input v-model="formItem.base" placeholder="请输入表底数"></Input>
      </FormItem>
    </Form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectMeter: {},
      formItem: {
        meterType: "0",
        operatation: "0",
        operatationType: "0",
        base: ""
      },
      isSpinShow: false
    };
  },
  mounted() {
    // console.log(this.selectMeter.row.meterTypeName);
    // console.log(this.selectMeter.row.meterTypeName.indexOf("阀"));
    // if(this.selectMeter.row.meterTypeName.indexOf("阀") >= 0){
    //   this.formItem.operatationType = "1";
    // }
  },
  methods: {
    downCharacteristic(meterInfo) {
      if(this.formItem.meterType == "1"){
        if(isNaN(parseInt(this.formItem.base)) || this.formItem.base.length > 8 || parseInt(this.formItem.base) < 0){
          this.$Notice.info({
            title: "提示",
            desc: "请输入正确的表底数（0~99999999）"
          });
          return -1;
        }
      }

      var that = this;
      var resultCode = 0;
      $.ajax({
        url: "/api/downCharacteristic",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          meterId: meterInfo.meterId,
          meterType: that.formItem.meterType,
          type: that.formItem.operatationType,
          operation: that.formItem.operatation,
          base: that.formItem.base
        }),
        async: false,
        dataType: "json",
        success: function(receiveData) {
          resultCode = receiveData.errorCode;

          that.isSpinShow = false;
        },
        error: function(textStatus) {
          resultCode = -1;
          that.isSpinShow = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });

      return resultCode;
    }
  },
  created() {}
};
</script>
<style>
.spin-icon-load {
  animation: ani-spin 1s linear infinite;
}

@keyframes ani-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>